import { MessageTypes } from '../../constants/messageConst.js'
import { ruleResult, ruleResultMessage } from './pipelineResult.js'

let claimantIsPolicyholder = (context) => {
    if (context) {
        let { objectInstance } = context
        if (objectInstance) {
            let { claimantDetails } = objectInstance
            if (claimantDetails && claimantDetails.policyholder == true) {
                return ruleResult(11, 'claimantIsPolicyholder', true, null)
            }
        }

        return ruleResult(11, 'claimantIsPolicyholder', false, ruleResultMessage(MessageTypes.MSG_MSG_WARNING, 'Claimant is not policyholder!'))
    }
}

let claimantTitleCompare = (context) => {
    if (context) {
        let { objectInstance } = context
        if (objectInstance) {
            let { claimantDetails, policyDetails } = objectInstance
            if (claimantDetails && policyDetails) {
                let { policyholder } = policyDetails.deserialisedObject
                if (policyholder && claimantDetails.title == policyholder.title)
                    return ruleResult(11, 'claimantTitleCompare', true, null)
            }
        }

        return ruleResult(11, 'claimantTitleCompare', false, ruleResultMessage(MessageTypes.MSG_MSG_WARNING, 'Claimant and policyholder title are different!'))
    }
}

let claimantFirstnameCompare = (context) => {
    if (context) {
        let { objectInstance } = context
        if (objectInstance) {
            let { claimantDetails, policyDetails } = objectInstance
            if (claimantDetails && policyDetails) {
                let { policyholder } = policyDetails.deserialisedObject
                if (policyholder && claimantDetails.firstname == policyholder.firstname)
                    return ruleResult(11, 'claimantFirstnameCompare', true, null)
            }
        }

        return ruleResult(11, 'claimantFirstnameCompare', false, ruleResultMessage(MessageTypes.MSG_MSG_WARNING, 'Claimant and policyholder first name are different!'))
    }
}

let claimantLastnameCompare = (context) => {
    if (context) {
        let { objectInstance } = context
        if (objectInstance) {
            let { claimantDetails, policyDetails } = objectInstance
            if (claimantDetails && policyDetails) {
                let { policyholder } = policyDetails.deserialisedObject
                if (policyholder && claimantDetails.lastname == policyholder.lastname)
                    return ruleResult(11, 'claimantLastnameCompare', true, null)
            }
        }

        return ruleResult(11, 'claimantLastnameCompare', false, ruleResultMessage(MessageTypes.MSG_MSG_WARNING, 'Claimant and policyholder last name are different!'))
    }
}

let claimantEmailCompare = (context) => {
    if (context) {
        let { objectInstance } = context
        if (objectInstance) {
            let { claimantDetails, policyDetails } = objectInstance
            if (claimantDetails && policyDetails) {
                let { policyholder } = policyDetails.deserialisedObject
                if (policyholder && claimantDetails.email == policyholder.emailAddress)
                    return ruleResult(11, 'claimantEmailCompare', true, null)
            }
        }

        return ruleResult(11, 'claimantEmailCompare', false, ruleResultMessage(MessageTypes.MSG_MSG_WARNING, 'Claimant and policyholder emails are different!'))
    }
}

let claimantTelephoneCompare = (context) => {
    if (context) {
        let { objectInstance } = context
        if (objectInstance) {
            let { claimantDetails, policyDetails } = objectInstance
            if (claimantDetails && policyDetails) {
                let { policyholder } = policyDetails.deserialisedObject
                if (policyholder && claimantDetails.telephone == policyholder.telephone)
                    return ruleResult(11, 'claimantTelephoneCompare', true, null)
            }
        }

        return ruleResult(11, 'claimantTelephoneCompare', false, ruleResultMessage(MessageTypes.MSG_MSG_WARNING, 'Claimant and policyholder telephone numbers are different!'))
    }
}

export {
    claimantIsPolicyholder,
    claimantTitleCompare,
    claimantFirstnameCompare,
    claimantLastnameCompare,
    claimantEmailCompare,
    claimantTelephoneCompare
}